module.exports = __webpack_public_path__ + "img/rekuperace1.27547c11.svg";